import React, { useCallback } from "react";
import { Link, useHistory } from "react-router-dom";
import moment from "moment-timezone";

const ProspectHeader = (props) => {
  let {
    firstName,
    lastName,
    createdAt,
    assigneeName,
  } = props.data;

  const history = useHistory();

  const handleGoBack = useCallback(() => {
    if (history.length > 1) {
      history.goBack();
    } else {
      history.push("/prospects");
    }
  }, [history]);

  return (
    <div id="page-header" className="prospect-header">
      <div className="back-button-container">
        <div onClick={handleGoBack} className="base-button icon-button evo-blue mr-10">
          <span className="material-icons">chevron_left</span>
        </div>
      </div>

      <div id="page-title-container">
        <h1 className="page-title">{firstName} {lastName}</h1>
        <p className="created-on">Created on {moment(createdAt).format("MMM D, YYYY")}</p>
        <p className="owner-name">Owned by {assigneeName}</p>
      </div>

      <div id="page-breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/prospects">Prospects</Link>
          </li>
          <span className="material-icons">chevron_right</span>
          <li className="breadcrumb-item active">{firstName} {lastName}</li>
        </ol>
      </div>
    </div>
  );
};

export default ProspectHeader;
